import { object, string, InferType } from 'yup';
import { AiCareDocumentTreatmentDetailsSchema } from './AiCareDocumentTreatmentDetailsSchema';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { deepPartialOrNullable } from '../../../../helpers';
import {
  EndOfCareSummaryExpertSummarySchema,
  EndOfCareSummaryReturnToWorkSchema,
} from '../endOfCareSummary';
import { AiDateSchema } from './AiDateSchema';

export const EndOfCareSummaryAiGeneratedSchema = object().shape({
  patient: object()
    .shape({
      dob: AiDateSchema,
      cancerType: string().nullable().notRequired(),
      dateOfDiagnosis: AiDateSchema,
    })
    .nullable()
    .notRequired(),

  dateOfConsultation: AiDateSchema,

  endOfCareDate: AiDateSchema,

  treatmentDetails: deepPartialOrNullable(AiCareDocumentTreatmentDetailsSchema)
    .nullable()
    .notRequired(),

  returnToWorkStatus: deepPartialOrNullable(
    EndOfCareSummaryReturnToWorkSchema,
  ).notRequired(),

  additionalCommunicationNotes: string().nullable().notRequired(),

  expertSummary: deepPartialOrNullable(EndOfCareSummaryExpertSummarySchema)
    .nullable()
    .notRequired(),
});

export type EndOfCareSummaryAiGenerated = InferType<
  typeof EndOfCareSummaryAiGeneratedSchema
>;

export const EndOfCareSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(EndOfCareSummaryAiGeneratedSchema);

export type EndOfCareSummaryAiGeneratedResponse = InferType<
  typeof EndOfCareSummaryAiGeneratedResponseSchema
>;
